import axios from "../axios";
import AuthenticationState from "../state/AuthenticationState";
import ProfileState from "../state/ProfileState";
import ProfileService from "./ProfileService";

class AuthenticationService {
  authenticate(email, password, rememberMe = true) {
    const url = 'password-login';
    return new Promise((resolve, reject) => {
      axios
        .post(url, this.getAuthRequest(email, password))
        .then(response => {
            ProfileState.registerApiCallDate();
            resolve(this.checkToken(response, rememberMe));
        })
        .catch(error => {
          ProfileState.clear();
          reject(error);
        });
    });
  }

  refresh() {
    return new Promise((resolve, reject) => {
      const url = 'refresh-token';
      axios
        .post(url, this.getRefreshTokenRequest())
        .then(response => {
          if (response.status === 200) {
            AuthenticationState.updateTokens(response.data.access_token, response.data.refresh_token);
            resolve(true);
          } else {
            reject('Cannot get a new token');
          }
        })
        .catch(error => {
          ProfileState.clear();
          reject(error);
        });
    });
  }

  checkToken(response, rememberMe = true) {
    return new Promise((resolve, reject) => {
      if (!response.data || !response.data.access_token) {
        ProfileState.clear();
        reject(new Error('Login failed!'));
      } else {
        AuthenticationState.updateTokens(response.data.access_token, response.data.refresh_token);
        resolve(ProfileService.getProfile(rememberMe));
      }
    });
  }

    sendResetEmail(email, url) {
        return new Promise((resolve, reject) => {
            axios
                .post(`forgot-password`, { email: email, url: url })
                .then(response => resolve(response))
                .catch(error => {
                    reject(error);
                });
        });
    }

    resetPassword(userId, validationToken, password) {
        return new Promise((resolve, reject) => {
            axios
                .post(`reset-password/${userId}/${validationToken}`, { newPassword: password })
                .then(response => resolve(response))
                .catch(error => {
                    reject(error);
                });
        });
    }

    passwordlessAccess(email, url) {
        return new Promise((resolve, reject) => {
            axios.post('passwordless-access', { email: email, url: url })
                 .then(response => resolve(response))
                 .catch(error => reject(error));
        });
    }

    magicLinkAccessToken(userId, validationToken) {
        return new Promise((resolve, reject) => {
            axios.get(`auth-token/${userId}/${validationToken}`)
                 .then(response => {
                     if (response.status === 200) {
                         AuthenticationState.updateTokens(response.data.accessToken, null);
                         return resolve(response);
                     }
                     return reject('Cannot get a new token');
                 })
                 .catch(error => reject(error));
        });
    }

  getAuthRequest(email, password) {
    return {
      email: email,
      password: password,
    };
  }

  getRefreshTokenRequest() {
    return {
      // eslint-disable-next-line @typescript-eslint/camelcase
      grant_type: 'refresh_token',
      // eslint-disable-next-line @typescript-eslint/camelcase
      refresh_token: AuthenticationState.refreshToken,
      // eslint-disable-next-line @typescript-eslint/camelcase
      client_id: AuthenticationState.clientId,
      // eslint-disable-next-line @typescript-eslint/camelcase
      client_secret: AuthenticationState.clientSecret,
      scope: ''
    };
  }
}

export default new AuthenticationService();
